export const BlogCategories = [
    'Conciencia',
    'Energía',
    'Mente',
    'Cuerpo',
    'Visión Bodhiwell'
];
